// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Y-oM","col":"styles_col__3s3G_"};